import { Controller } from "@hotwired/stimulus"

// リマインダーフォームでスケジュール種別に応じたフィールド表示を制御
export default class extends Controller {
  static targets = ["onceFields", "recurringFields", "weeklyFields", "monthlyFields", "holidayFields"]

  static FIELD_SELECTOR = "input, select, textarea, button, wa-input, wa-select, wa-textarea, wa-radio-group, wa-checkbox"

  connect() {
    this.applyToggle(this.currentScheduleType())
  }

  toggle(event) {
    const value = event.detail?.value ?? event.target.value
    this.applyToggle(value)
  }

  currentScheduleType() {
    const selected = this.element.querySelector("[name='reminder[schedule_type]'] wa-radio[checked], [name='reminder[schedule_type]'] input:checked")
    return selected?.getAttribute("value") ?? selected?.value ?? "once"
  }

  applyToggle(type) {
    const isOnce = type === "once"
    const showWeekly = type === "weekly"
    const showMonthly = type === "monthly"
    const showHoliday = showWeekly || showMonthly

    this.toggleTargets(this.onceFieldsTargets, isOnce)
    this.toggleTargets(this.recurringFieldsTargets, !isOnce)
    this.toggleTargets(this.weeklyFieldsTargets, showWeekly)
    this.toggleTargets(this.monthlyFieldsTargets, showMonthly)
    this.toggleTargets(this.holidayFieldsTargets, showHoliday)
  }

  toggleTargets(targets, show) {
    targets.forEach((el) => {
      el.hidden = !show
      el.querySelectorAll(this.constructor.FIELD_SELECTOR).forEach((f) => { f.disabled = !show })
    })
  }
}
